import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from '../src/store';
import { Provider } from 'react-redux';
import checkAndRefreshIfStale from './utils/versionRefresh';

checkAndRefreshIfStale();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

reportWebVitals();
